/**
 * Componente para el botón de Alertas de la navegación inferior
 * Muestra contador de interacciones (me gustas + visitas) y notificación visual
 * Adaptado de la versión móvil
 */

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HeartIcon from '../../Icons/HeartIcon';

const AlertsButton = ({ interactionCount = 0, onReset, disableNavigation = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determinar si la ruta actual es la de interacciones
  const isActive = location.pathname === '/interacciones';
  
  // Estado para mostrar etiqueta descriptiva temporalmente
  const [showLabel, setShowLabel] = useState(false);
  
  /**
   * Efecto para manejar la etiqueta descriptiva
   * Muestra "Interacción/Interacciones" durante 2 segundos cuando cambia el contador
   */
  useEffect(() => {
    if (interactionCount > 0) {
      setShowLabel(true);
      const timer = setTimeout(() => {
        setShowLabel(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [interactionCount]);
  
  /**
   * Maneja la navegación a la pantalla de interacciones
   * Reinicia contadores antes de navegar si hay interacciones pendientes
   */
  const handlePress = () => {
    if (!disableNavigation) {
      // Reiniciar contadores si hay interacciones pendientes
      if (interactionCount > 0 && onReset) {
        onReset();
      }
      navigate('/interacciones');
    }
  };
  
  /**
   * Estilo del botón según estado activo
   */
  const buttonStyle = `
    relative flex flex-col items-center justify-center
    w-20 h-12 rounded-full transition-all duration-200
    ${isActive ? 'bg-neutral-700' : 'hover:bg-neutral-800'}
  `;
  
  /**
   * Texto de la etiqueta condicional
   */
  const labelText = showLabel && interactionCount > 0 
    ? (interactionCount === 1 ? 'Interacción' : 'Interacciones')
    : '';
  
  return (
    <button
      className={buttonStyle}
      onClick={handlePress}
      aria-label="Ir a interacciones"
    >
      {/* Icono de corazón */}
      <HeartIcon
        active={isActive || interactionCount > 0}
        size={32}
        color="#A89CA6"
      />
      
      {/* Indicador de punto rojo cuando hay interacciones */}
      {interactionCount > 0 && (
        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-4 h-2 bg-primary rounded-t-lg" />
      )}
      
      {/* Etiqueta descriptiva temporal */}
      {labelText && (
        <span className="absolute -top-8 bg-primary text-white text-xs px-2 py-1 rounded">
          {labelText}
        </span>
      )}
    </button>
  );
};

export default AlertsButton;
